/* global Shopify */
(function () {
  'use strict';

  // ── Simple Modern color name → hex lookup ─────────────────────────
  const COLOR_MAP = {
    'Alpine White':   { hex: '#f0f0ee', light: true },
    'White':          { hex: '#f0f0ee', light: true },
    'Midnight Navy':  { hex: '#1a2744' },
    'Navy':           { hex: '#1a2744' },
    'Desert Blush':   { hex: '#e8a090' },
    'Blush':          { hex: '#f5c0c8' },
    'Forest Green':   { hex: '#2d5a3d' },
    'Green':          { hex: '#2d5a3d' },
    'Teal':           { hex: '#1a8a8a' },
    'Lavender':       { hex: '#9b8ec4' },
    'Terracotta':     { hex: '#c4652a' },
    'Terra':          { hex: '#c4652a' },
    'Black':          { hex: '#222222' },
    'Matte Black':    { hex: '#111111' },
    'Jet Black':      { hex: '#111111' },
    'Sage':           { hex: '#8aaa8a' },
    'Coral':          { hex: '#e8736a' },
    'Periwinkle':     { hex: '#7899d4' },
    'Bubblegum':      { hex: '#f5a0c0' },
    'Lilac':          { hex: '#c8b0e0' },
    'Aqua':           { hex: '#4ac8d8' },
    'Slate':          { hex: '#6a7a8a' },
    'Charcoal':       { hex: '#4a4a4a' },
    'Sand':           { hex: '#d4b896' },
    'Cream':          { hex: '#f5f0e0', light: true },
    'Tan':            { hex: '#c4a882' },
    'Rose Gold':      { hex: '#d4a0a0' },
    'Gold':           { hex: '#d4a040' },
    'Silver':         { hex: '#c0c0c0', light: true },
    'Cinnamon':       { hex: '#a0522d' },
    'Almond':         { hex: '#efdecd', light: true },
    'Slate Blue':     { hex: '#5470a0' },
    'Pink':           { hex: '#f5a0b0' },
    'Purple':         { hex: '#7b4fa0' },
    'Red':            { hex: '#c42020' },
    'Orange':         { hex: '#d46020' },
    'Yellow':         { hex: '#d4c020', light: true },
    'Blue':           { hex: '#2050a0' },
    'Olive':          { hex: '#6b6b30' },
    'Maroon':         { hex: '#6b1520' },
  };

  function getSwatchHex(optionValue) {
    if (!optionValue) return '#cccccc';
    if (COLOR_MAP[optionValue]) return COLOR_MAP[optionValue].hex;
    const exactKey = Object.keys(COLOR_MAP).find(
      k => k.toLowerCase() === optionValue.toLowerCase()
    );
    if (exactKey) return COLOR_MAP[exactKey].hex;
    const partialKey = Object.keys(COLOR_MAP).find(
      k => optionValue.toLowerCase().includes(k.toLowerCase())
    );
    if (partialKey) return COLOR_MAP[partialKey].hex;
    // Hash-based fallback for unknown colors
    let hash = 0;
    for (let i = 0; i < optionValue.length; i++) {
      hash = optionValue.charCodeAt(i) + ((hash << 5) - hash);
    }
    return 'hsl(' + (Math.abs(hash) % 360) + ',40%,60%)';
  }

  function isLightColor(optionValue) {
    if (!optionValue) return false;
    const key = Object.keys(COLOR_MAP).find(
      k => k.toLowerCase() === optionValue.toLowerCase()
    );
    return !!(key && COLOR_MAP[key].light);
  }

  // ── Helpers ───────────────────────────────────────────────────────
  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function shadeColor(hex, amount) {
    if (!hex.startsWith('#')) return hex;
    const num = parseInt(hex.replace('#', ''), 16);
    const r = Math.min(255, Math.max(0, (num >> 16) + amount));
    const g = Math.min(255, Math.max(0, ((num >> 8) & 0xff) + amount));
    const b = Math.min(255, Math.max(0, (num & 0xff) + amount));
    return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
  }

  const $ = id => document.getElementById(id);
  const qs = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  // ── State ─────────────────────────────────────────────────────────
  let bundles = [];
  let currentBundle = null;
  let currentSlot = 0;
  let slotPicks = []; // variant object or null per slot

  // ── Screen management ─────────────────────────────────────────────
  function showScreen(name) {
    qsa('.byb-screen').forEach(s => s.classList.remove('is-active'));
    const el = $('byb-screen-' + name);
    if (el) {
      el.classList.add('is-active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // ── Boot ─────────────────────────────────────────────────────────
  function init() {
    const dataEl = qs('script[type="application/json"][id^="byb-bundle-data-"]');
    if (!dataEl) return;

    try {
      bundles = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      console.error('[BYB] Failed to parse bundle data:', e);
      return;
    }

    if (!Array.isArray(bundles) || !bundles.length) {
      const grid = $('byb-bundle-grid');
      if (grid) grid.innerHTML = '<p style="color:#888;font-size:14px;">No bundles configured. Add a Bundle block in the theme editor.</p>';
      showScreen('selector');
      return;
    }

    renderSelector();
    showScreen('selector');
    wireStaticButtons();
  }

  // ── Selector Screen ───────────────────────────────────────────────
  function renderSelector() {
    const grid = $('byb-bundle-grid');
    if (!grid) return;
    grid.innerHTML = '';

    bundles.forEach((bundle, idx) => {
      const subtotal = bundle.products.reduce((sum, p) => {
        const v = p.variants.find(x => x.available) || p.variants[0];
        return sum + (v ? v.price : 0);
      }, 0);
      const discounted = Math.round(subtotal * (1 - bundle.discountPct / 100));

      const imgsHtml = bundle.products.slice(0, 4).map((p, pi) => {
        const v = p.variants[0];
        if (!v || !v.image) return '';
        const heights = [88, 76, 80, 72];
        return '<img class="byb-btile-img" style="height:' + (heights[pi] || 80) + 'px" src="' + v.image + '" alt="' + p.title + '" loading="lazy">';
      }).join('');

      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'byb-btile';
      tile.innerHTML =
        '<div class="byb-btile-top-label">' + (bundle.label || '&nbsp;') + '</div>' +
        '<div class="byb-btile-imgs">' + (imgsHtml || '<div class="byb-btile-custom-icon">+</div>') + '</div>' +
        '<div class="byb-btile-name">' + bundle.name + '</div>' +
        '<div class="byb-btile-desc">' + bundle.products.map(p => p.title).join(' · ') + '</div>' +
        '<div class="byb-btile-price-line"><s>' + fmtMoney(subtotal) + '</s> &rarr; <strong>' + fmtMoney(discounted) + '</strong></div>' +
        '<div class="byb-btile-badge">SAVE ' + bundle.discountPct + '%</div>';

      tile.addEventListener('click', () => selectBundle(idx));
      grid.appendChild(tile);
    });
  }

  // ── Builder Screen ────────────────────────────────────────────────
  function selectBundle(idx) {
    currentBundle = bundles[idx];
    currentSlot = 0;
    slotPicks = new Array(currentBundle.products.length).fill(null);

    renderStepTrack();
    renderSlotCards();
    renderPriceBreakdown();

    const crumb = $('byb-builder-crumb');
    if (crumb) crumb.textContent = currentBundle.name;

    const title = $('byb-summary-title');
    if (title) title.textContent = currentBundle.name;

    const btnAtc = $('byb-btn-atc');
    if (btnAtc) { btnAtc.disabled = true; btnAtc.textContent = 'ADD BUNDLE TO CART'; }

    const note = $('byb-summary-note');
    if (note) note.textContent = 'Select all ' + currentBundle.products.length + ' colors to continue';

    const err = $('byb-cart-error');
    if (err) err.classList.remove('is-visible');

    activateSlot(0);
    showScreen('builder');
  }

  function renderStepTrack() {
    const track = $('byb-step-track');
    if (!track) return;
    track.innerHTML = '';

    currentBundle.products.forEach((product, i) => {
      const node = document.createElement('div');
      node.className = 'byb-step-node';
      const shortTitle = product.title.split(' ').slice(0, 2).join(' ');
      node.innerHTML =
        '<div class="byb-step-circle" id="byb-sc-' + i + '">' + (i + 1) + '</div>' +
        '<span class="byb-step-label" id="byb-sl-' + i + '">' + shortTitle + '</span>';
      track.appendChild(node);

      if (i < currentBundle.products.length - 1) {
        const conn = document.createElement('div');
        conn.className = 'byb-step-connector';
        conn.id = 'byb-scon-' + i;
        track.appendChild(conn);
      }
    });
  }

  function renderSlotCards() {
    const container = $('byb-slot-cards');
    if (!container) return;
    container.innerHTML = '';

    currentBundle.products.forEach((product, i) => {
      if (i > 0) {
        const plus = document.createElement('div');
        plus.className = 'byb-slot-plus';
        plus.textContent = '+';
        container.appendChild(plus);
      }

      const card = document.createElement('div');
      card.id = 'byb-slot-' + i;
      card.className = 'byb-slot-card ' + (i === 0 ? 'is-active' : 'is-empty');
      card.innerHTML =
        '<div class="byb-slot-thumb">' +
          '<svg width="18" height="46" viewBox="0 0 36 88">' +
            '<path id="byb-tp-' + i + '" d="M14,4 L12,12 Q6,16 6,24 L6,76 Q6,82 12,82 L24,82 Q30,82 30,76 L30,24 Q30,16 24,12 L22,4 Z" fill="none" stroke="#ccc" stroke-width="3"/>' +
            '<rect x="13" y="1" width="10" height="5" rx="2" fill="none" stroke="#ccc" stroke-width="2"/>' +
          '</svg>' +
        '</div>' +
        '<div class="byb-slot-info">' +
          '<div class="byb-slot-name">' + product.title + '</div>' +
          '<div class="byb-slot-color" id="byb-sct-' + i + '">Tap to choose color</div>' +
        '</div>' +
        '<svg class="byb-slot-status" id="byb-ssi-' + i + '" viewBox="0 0 20 20" fill="none">' +
          '<circle cx="10" cy="10" r="8.5" stroke="#ddd" stroke-width="1.5"/>' +
        '</svg>';

      card.addEventListener('click', () => activateSlot(i));
      container.appendChild(card);
    });
  }

  function activateSlot(i) {
    currentSlot = i;

    qsa('.byb-slot-card').forEach((el, n) => {
      el.classList.remove('is-active');
      if (!slotPicks[n]) el.classList.add('is-empty');
      else el.classList.remove('is-empty');
    });

    const active = $('byb-slot-' + i);
    if (active) { active.classList.remove('is-empty'); active.classList.add('is-active'); }

    renderPicker(i);
  }

  function renderPicker(i) {
    const product = currentBundle.products[i];
    if (!product) return;

    updateStepTrack(i);

    const stepLbl = $('byb-picker-step-label');
    if (stepLbl) stepLbl.textContent = 'Step ' + (i + 1) + ' of ' + currentBundle.products.length;

    const heading = $('byb-picker-heading');
    if (heading) heading.textContent = 'Choose your ' + product.title;

    const sub = $('byb-picker-sub');
    if (sub) {
      if (i === 0) sub.textContent = 'Select a color to add to your ' + currentBundle.name;
      else if (i === currentBundle.products.length - 1) sub.textContent = 'Last one — complete your bundle!';
      else sub.textContent = 'Mix and match — any color combination works!';
    }

    const nameEl = $('byb-pp-name');
    if (nameEl) nameEl.textContent = product.title;

    const selectedVariant = slotPicks[i];
    const displayVariant = selectedVariant || (product.variants.find(v => v.available) || product.variants[0]);

    if (displayVariant) {
      const priceEl = $('byb-pp-price');
      if (priceEl) priceEl.textContent = fmtMoney(displayVariant.price);

      const discEl = $('byb-pp-discounted');
      if (discEl) discEl.textContent = fmtMoney(Math.round(displayVariant.price * (1 - currentBundle.discountPct / 100)));

      const imgEl = $('byb-pp-img');
      if (imgEl) {
        const src = (selectedVariant || displayVariant).image;
        imgEl.innerHTML = src ? '<img src="' + src + '" alt="' + product.title + '">' : '';
      }
    }

    const colorNameEl = $('byb-color-name-display');
    if (colorNameEl) {
      if (selectedVariant) {
        colorNameEl.textContent = selectedVariant.optionValue || selectedVariant.title;
        colorNameEl.style.color = 'var(--byb-black)';
      } else {
        colorNameEl.textContent = 'Choose a color';
        colorNameEl.style.color = 'var(--byb-gray-4)';
      }
    }

    const btnAdd = $('byb-btn-add');
    if (btnAdd) btnAdd.disabled = !selectedVariant;

    renderSwatches(i, product);
  }

  function renderSwatches(slotIdx, product) {
    const row = $('byb-swatch-row');
    if (!row) return;
    row.innerHTML = '';

    const selectedVariant = slotPicks[slotIdx];

    product.variants.forEach(variant => {
      if (!variant.available) return;
      const optVal = variant.optionValue || variant.title;
      const hex = getSwatchHex(optVal);
      const light = isLightColor(optVal);
      const selected = selectedVariant && selectedVariant.id === variant.id;

      const swatch = document.createElement('div');
      swatch.className = 'byb-swatch' + (light ? ' byb-swatch--light' : '') + (selected ? ' is-selected' : '');
      swatch.style.background = hex;
      swatch.innerHTML = '<span class="byb-swatch-tooltip">' + optVal + '</span>';
      swatch.addEventListener('click', () => {
        slotPicks[slotIdx] = variant;
        renderPicker(slotIdx);
      });
      row.appendChild(swatch);
    });
  }

  function updateStepTrack(activeIdx) {
    currentBundle.products.forEach((_, i) => {
      const circ = $('byb-sc-' + i);
      const lbl = $('byb-sl-' + i);
      if (!circ || !lbl) return;

      circ.classList.remove('is-active', 'is-done');
      lbl.classList.remove('is-active', 'is-done');

      if (slotPicks[i]) {
        circ.innerHTML = '✓';
        circ.classList.add('is-done');
        lbl.classList.add('is-done');
      } else if (i === activeIdx) {
        circ.innerHTML = String(i + 1);
        circ.classList.add('is-active');
        lbl.classList.add('is-active');
      } else {
        circ.innerHTML = String(i + 1);
      }

      if (i < currentBundle.products.length - 1) {
        const conn = $('byb-scon-' + i);
        if (conn) conn.classList.toggle('is-done', !!slotPicks[i]);
      }
    });
  }

  function renderPriceBreakdown() {
    const container = $('byb-price-rows');
    if (!container || !currentBundle) return;
    container.innerHTML = '';

    const subtotal = currentBundle.products.reduce((sum, p) => {
      const v = p.variants.find(x => x.available) || p.variants[0];
      return sum + (v ? v.price : 0);
    }, 0);
    const discountAmt = Math.round(subtotal * currentBundle.discountPct / 100);
    const total = subtotal - discountAmt;

    currentBundle.products.forEach(p => {
      const v = p.variants.find(x => x.available) || p.variants[0];
      const row = document.createElement('div');
      row.className = 'byb-price-row';
      row.innerHTML = '<span>' + p.title + '</span><span>' + fmtMoney(v ? v.price : 0) + '</span>';
      container.appendChild(row);
    });

    const discRow = document.createElement('div');
    discRow.className = 'byb-price-row byb-price-row--discount';
    discRow.innerHTML = '<span>Bundle Discount (' + currentBundle.discountPct + '%)</span><span>−' + fmtMoney(discountAmt) + '</span>';
    container.appendChild(discRow);

    const totalRow = document.createElement('div');
    totalRow.className = 'byb-price-row byb-price-row--total';
    totalRow.innerHTML = '<span>Total</span><span>' + fmtMoney(total) + '</span>';
    container.appendChild(totalRow);
  }

  // Confirm the current slot's color selection
  function confirmSlot() {
    const i = currentSlot;
    const variant = slotPicks[i];
    if (!variant) return;

    const hex = getSwatchHex(variant.optionValue || variant.title);

    // Mark slot card done
    const card = $('byb-slot-' + i);
    if (card) { card.classList.remove('is-active', 'is-empty'); card.classList.add('is-done'); }

    const sct = $('byb-sct-' + i);
    if (sct) { sct.textContent = variant.optionValue || variant.title; sct.classList.add('has-pick'); }

    const ssi = $('byb-ssi-' + i);
    if (ssi) ssi.innerHTML = '<circle cx="10" cy="10" r="9" fill="#1a7a35"/><polyline points="5.5,10 8.5,13 14.5,7" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';

    const tp = $('byb-tp-' + i);
    if (tp) { tp.setAttribute('fill', hex); tp.setAttribute('stroke', shadeColor(hex, -30)); }

    const next = slotPicks.indexOf(null);
    if (next !== -1) {
      setTimeout(() => activateSlot(next), 280);
    } else {
      const btnAtc = $('byb-btn-atc');
      if (btnAtc) btnAtc.disabled = false;
      const note = $('byb-summary-note');
      if (note) note.textContent = '🎉 Bundle complete — ready to add to cart!';
    }
  }

  // ── Cart Submission ───────────────────────────────────────────────
  async function addBundleToCart() {
    const btnAtc = $('byb-btn-atc');
    const errEl = $('byb-cart-error');
    if (errEl) errEl.classList.remove('is-visible');
    if (btnAtc) { btnAtc.disabled = true; btnAtc.textContent = 'ADDING…'; }

    const items = slotPicks.filter(Boolean).map(v => ({
      id: v.id,
      quantity: 1,
      properties: {
        '_bundle_name': currentBundle.name,
        '_bundle_discount': currentBundle.discountPct + '%',
      },
    }));

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items }),
      });

      if (!addRes.ok) {
        const errData = await addRes.json().catch(() => ({}));
        throw new Error(errData.description || 'Could not add items to cart.');
      }

      // Refresh the header cart count
      const cartRes = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('.js-cart-item-count').forEach(el => {
          el.textContent = cart.item_count;
          el.setAttribute('data-item-count', cart.item_count);
        });
      }

      renderSuccess();
      showScreen('success');

      // Open the theme's cart drawer
      document.dispatchEvent(new CustomEvent('theme:cart_drawer_open_request'));

    } catch (err) {
      console.error('[BYB] Cart error:', err);
      if (btnAtc) { btnAtc.disabled = false; btnAtc.textContent = 'ADD BUNDLE TO CART'; }
      if (errEl) { errEl.textContent = err.message || 'Something went wrong. Please try again.'; errEl.classList.add('is-visible'); }
    }
  }

  // ── Success Screen ────────────────────────────────────────────────
  function renderSuccess() {
    const nameEl = $('byb-success-bundle-name');
    if (nameEl) nameEl.textContent = currentBundle.name;

    const cards = $('byb-success-cards');
    if (cards) {
      cards.innerHTML = '';
      slotPicks.forEach((variant, i) => {
        const product = currentBundle.products[i];
        if (!product) return;
        const colorName = variant ? (variant.optionValue || variant.title) : '—';
        const card = document.createElement('div');
        card.className = 'byb-success-pcard';
        card.innerHTML =
          (variant && variant.image ? '<div class="byb-success-pcard-img"><img src="' + variant.image + '" alt="' + product.title + '" loading="lazy"></div>' : '') +
          '<div class="byb-success-pcard-body">' +
            '<div class="byb-success-pcard-name">' + product.title + '</div>' +
            '<div class="byb-success-pcard-color">' + colorName + '</div>' +
            '<div class="byb-success-pcard-price">' + (variant ? fmtMoney(variant.price) : '') + '</div>' +
          '</div>';
        cards.appendChild(card);
      });
    }

    const lines = $('byb-success-order-lines');
    if (lines) {
      lines.innerHTML = '';
      slotPicks.forEach((variant, i) => {
        const product = currentBundle.products[i];
        if (!product || !variant) return;
        const line = document.createElement('div');
        line.className = 'byb-success-order-line';
        line.innerHTML = '<span>' + product.title + ' — ' + (variant.optionValue || variant.title) + '</span><span>' + fmtMoney(variant.price) + '</span>';
        lines.appendChild(line);
      });
    }

    const subtotal = slotPicks.reduce((s, v) => s + (v ? v.price : 0), 0);
    const discountAmt = Math.round(subtotal * currentBundle.discountPct / 100);
    const total = subtotal - discountAmt;

    const discLbl = $('byb-success-discount-label');
    if (discLbl) discLbl.textContent = 'Bundle Discount (' + currentBundle.discountPct + '%)';

    const discAmt = $('byb-success-discount-amt');
    if (discAmt) discAmt.textContent = '−' + fmtMoney(discountAmt);

    const totalEl = $('byb-success-total');
    if (totalEl) totalEl.textContent = fmtMoney(total);
  }

  // ── Static button wiring (delegated) ─────────────────────────────
  function wireStaticButtons() {
    document.addEventListener('click', e => {
      const action = e.target.closest('[data-byb-action]');
      if (!action) return;
      switch (action.getAttribute('data-byb-action')) {
        case 'show-selector':  e.preventDefault(); showScreen('selector'); break;
        case 'confirm-slot':   confirmSlot(); break;
        case 'add-to-cart':    addBundleToCart(); break;
        case 'open-cart':      document.dispatchEvent(new CustomEvent('theme:cart_drawer_open_request')); break;
        case 'continue-shopping': showScreen('selector'); break;
      }
    });
  }

  // ── Mount ─────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
